// Mirrors backend com.kervolt.oms.cashforecast.dto.CashForecastDtos (W3-L).

export type ForecastConfidence = 'FIRM' | 'EXPECTED' | 'ESTIMATE';
export type ForecastDirection = 'INFLOW' | 'OUTFLOW';
export type AdjustmentRecurrence = 'NONE' | 'WEEKLY' | 'MONTHLY';
export type OverdueArHandling = 'WEEK_1' | 'EXCLUDE';

export const FORECAST_CONFIDENCES: ForecastConfidence[] = ['FIRM', 'EXPECTED', 'ESTIMATE'];

export interface ForecastWeek { index: number; start: string; end: string }

export interface ForecastRow {
  key: string; label: string; direction: ForecastDirection; sourceKey: string;
  weekly: number[]; total: number; itemCount: number;
}

export interface OdMemo { totalLimit: number; utilised: number; headroom: number }

export interface ForecastResponse {
  institutionId: string; forecastDate: string; horizonEnd: string; weeks: ForecastWeek[];
  openingBalance: number; minimumCash: number; inflows: ForecastRow[]; outflows: ForecastRow[];
  totalInflows: number[]; totalOutflows: number[]; net: number[]; opening: number[]; closing: number[];
  belowMinimum: boolean[]; odMemo?: OdMemo | null; confidences: ForecastConfidence[]; warnings: string[];
}

export interface ForecastItem {
  sourceKey: string; documentId?: string | null; documentRef?: string | null; expectedDate: string;
  amountBase: number; currencyCode?: string | null; foreignAmount?: number | null; counterparty?: string | null;
  confidence: ForecastConfidence; deepLink?: string | null;
}

export interface ForecastSettings {
  institutionId: string; exportRealizationDays: number; payrollPayDay: number; withholdingDepositDay: number;
  poPaymentLagDays: number; overdueArHandling: OverdueArHandling; minimumCash: number;
  overdueArCutoffDays: number; overdueApCutoffDays: number; saved: boolean;
}

export type ForecastSettingsRequest = Omit<ForecastSettings, 'institutionId' | 'saved'>;

export interface ForecastAdjustment {
  id: string; institutionId: string; adjustmentDate: string; direction: ForecastDirection; amount: number;
  category: string; description?: string | null; confidence: ForecastConfidence;
  recurrence: AdjustmentRecurrence; recurUntil?: string | null;
}

export interface ForecastAdjustmentRequest {
  adjustmentDate: string; direction: ForecastDirection; amount: number; category: string;
  description?: string; confidence: ForecastConfidence; recurrence: AdjustmentRecurrence; recurUntil?: string;
}
